import React, {useContext} from 'react'
import { PiPencilSimple, PiXLight } from 'react-icons/pi'
import { GlobalContext } from '../contexts/GlobalContext'
import { createRoot } from 'react-dom/client'
import FormDialog from './FormDialog'
import Edit from './Edit'

const EditableComplonent = ({title,Dialog,params,submit,children,hasAuthority}) => {
    const {editing,version,setVersion} = useContext(GlobalContext);
    return (
        <div className='relative w-full min-h-[32px]'>
            {children}
            {editing && hasAuthority &&
                <button onClick={(e) => {
                    e.stopPropagation();
                    const container = document.createElement("div");
                    container.style.left = '0';
                    container.style.top = '0';
                    container.style.right = '0';
                    container.style.bottom = '0'; 
                    container.style.position = 'fixed';
                    container.style.zIndex = 100;
                    container.style.overflow = 'hidden';
                    document.body.appendChild(container);

                    // Create a new React root
                    const root = createRoot(container);

                    // Define cleanup function
                    const close = () => {
                        root.unmount();
                        container.remove();
                        
                    };
                    // Render the component into the container
                    root.render(<Edit 
                        title={title}
                        Dialog={Dialog} 
                        params={params} 
                        submit={submit} 
                        close={close} 
                        version={version} 
                        setVersion={setVersion}/>);
                }} className='absolute flex justify-center items-center bottom-4 right-4 w-10 h-10  z-[100] rounded-full bg-white hover:text-theme shadow-lg'>
                    <PiPencilSimple size={16}/>
                </button>
            }
        </div>
    )
}

export default EditableComplonent